var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildings3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99935 0.664062H11.9993V3.9974H15.3327V15.3307H0.666016V3.9974H3.99935V0.664062ZM5.33268 13.9974H5.99935V9.9974H9.99935V13.9974H10.666V1.9974H5.33268V13.9974ZM11.9993 5.33073V13.9974H13.9993V5.33073H11.9993ZM8.66602 13.9974V11.3307H7.33268V13.9974H8.66602ZM3.99935 13.9974V5.33073H1.99935V13.9974H3.99935Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings3);
export default __webpack_public_path__ + "static/media/buildings-3.5c13dc22bf23f45d3cb2ccb4f6b1a663.svg";
export { ForwardRef as ReactComponent };